import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { SET_CODE_VERIFIER, SET_AUTH_STATE, SET_PATIENT_INFO, SET_PATIENT_TYPE } from 'helpers/types';
import { LoginEmailPageContent } from 'services/content';
import { useDispatch } from 'react-redux';
import styles from './style.module.css';
import AlertMessage from 'components/alert-message';
import hpPromo from 'assets/hey-pharmacist-devices.png';
import { Forms } from 'components';
import postOAuth from 'hooks/useOAuth';
import * as API from 'services/api';

const LoginEmail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const crypto = require('crypto');
  const [challenge, setChallenge] = useState(false);
  const [authState, setAuthState] = useState(false);
  const [emailSubmitted, setEmailSubmitted] = useState('');
  const [postToken] = postOAuth();

  useEffect(() => {
    function base64URLEncode(str) {
      return str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }

    const verifier = base64URLEncode(crypto.randomBytes(32));

    const OAuthState = crypto.randomBytes(32).toString('hex');

    dispatch({ type: SET_CODE_VERIFIER, payload: verifier });
    dispatch({ type: SET_AUTH_STATE, payload: OAuthState });

    function sha256(buffer) {
      return crypto.createHash('sha256').update(buffer).digest();
    }

    setChallenge(base64URLEncode(sha256(verifier)));
    setAuthState(OAuthState);
  }, [crypto, dispatch]);

  const exchangeAuthCode = async (authCode) => {
    var bodyFormData = new FormData();
    bodyFormData.append('client_id', window.OAUTH_CLIENTID);
    bodyFormData.append('code', authCode);
    bodyFormData.append('grant_type', 'authorization_code');
    const data = await postToken(bodyFormData);
    const patientData = await API.getPatientInfo();
    dispatch({ type: SET_PATIENT_TYPE, payload: data.patient_type });
    dispatch({ type: SET_PATIENT_INFO, payload: patientData });
    if (data.consent_required) {
      history.push('/pharmacy/dashboard/consent');
    } else {
      history.push('/pharmacy/dashboard');
    }
  };

  return (
    <div className="coop-l-container">
      <div id="login_email_page" className={`${styles.login_page} coop-l-medium-12 coop-l-large-12`}>
        <AlertMessage />
        <div className={`${styles.login_grid}`}>
          <div className={`${styles.left_column} drop-shadow coop-l-medium-12 coop-l-large-12`}>
            <h1 className={styles.form_header}>{LoginEmailPageContent.headingText}</h1>
            <div className={styles.form_container}>
              {challenge && emailSubmitted ? (
                <Forms.SignInEmailVerifyForm
                  submittedEmail={emailSubmitted}
                  authState={authState}
                  challenge={challenge}
                  callbackAuthExchange={(value) => exchangeAuthCode(value)}
                />
              ) : (
                <Forms.SignInEmailForm callbackEmail={(value) => setEmailSubmitted(value)} />
              )}
            </div>

            <p className={styles.link_text}>
              {LoginEmailPageContent.mobilePreText}{' '}
              <Link to="/pharmacy/login/mobile" className={styles.inLineLink}>
                {LoginEmailPageContent.mobileLinkText}
              </Link>
            </p>

            <div className={styles.line_break} />

            <p className={styles.link_text}>
              {LoginEmailPageContent.registerPreText}{' '}
              <Link to="/pharmacy/register" className={styles.inLineLink}>
                {LoginEmailPageContent.registerLinkText}
              </Link>
            </p>
          </div>
          <div className={styles.promo_image}>
            <img src={hpPromo} alt="Hey Pharmacist" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginEmail;
